import { Colors } from '@/components/common';

const serviceSatisfactionQuestionnaireStatuses = {
  Pendiente: 1,
  EnProceso: 2,
  Completado: 3,
  Cancelado: 4,
};

export const parseStateColorByQuestionnaireStatus = (statusId) => {
  switch (statusId) {
    case serviceSatisfactionQuestionnaireStatuses.EnProceso:
      return Colors.AUTUMN_MIST;
    case serviceSatisfactionQuestionnaireStatuses.Pendiente:
      return Colors.SWEETCORN;
    case serviceSatisfactionQuestionnaireStatuses.Completado:
      return Colors.CELADON;
    case serviceSatisfactionQuestionnaireStatuses.Cancelado:
      return Colors.BROWN;
    default: {
      return Colors.SWEETCORN;
    }
  }
};

export default serviceSatisfactionQuestionnaireStatuses;
